package uz.ferro.erp.ui

import emotion.react.css
import mui.material.Box
import mui.system.PropsWithSx
import mui.system.sx
import react.FC
import react.PropsWithChildren
import react.useContext
import uz.ferro.erp.AppContext
import uz.ferro.erp.NavigationContext
import uz.ferro.erp.pages.MAX_PAGE_AREA
import uz.ferro.erp.ui.footer.Footer
import uz.ferro.erp.ui.header.HeaderDesktop
import uz.ferro.erp.ui.header.HeaderMobile
import web.cssom.Auto
import web.cssom.ClassName
import web.cssom.integer
import web.cssom.pct
import web.cssom.px

external interface GenericPageProps : PropsWithChildren, PropsWithSx {
    var topFullWidthChildren: react.ReactNode?
}

val GenericPage = FC<GenericPageProps>() { props ->

    val navigator = useContext(NavigationContext)
    val appContext = useContext(AppContext)
    val isMobile = appContext.isMd.not()

    Box {
        sx {
            width = 100.pct
            height = 100.pct
        }

        if (isMobile) {
            HeaderMobile()
        } else {
            HeaderDesktop()
        }


        /* Content */
        Box {
            sx {
                width = 100.pct
                zIndex = integer(3)
            }

            css(ClassName("fill-space-height")) {}

            Box {
                +props.topFullWidthChildren
            }

            Box {
                sx {
                    width = 100.pct
                    maxWidth = MAX_PAGE_AREA
                    marginLeft = Auto.auto
                    marginRight = Auto.auto
                    padding = 16.px
                }

                +props.children
            }
        }

        Footer()
    }
}